/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgHorizontalScaling = (props: Props) => (
  <Icon viewBox="0 0 25 24" {...props}>
    <g fill="none">
      <path
        d="M17.5 7h-10v4.036H4.914l1.121-1.122L4.621 8.5l-3.536 3.536 3.536 3.535 1.414-1.414-1.121-1.121H7.5V17h10v-3.964h2.242l-1.12 1.121 1.413 1.414 3.536-3.535L20.035 8.5l-1.414 1.414 1.121 1.122H17.5zm-8 8V9h6v6z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgHorizontalScaling as HorizontalScaling };
